<template>
    <v-container fluid>
        <v-row>
            <v-col
                cols="12"
            >
                <v-alert
                    color="light-blue darken-4"
                    dark
                    icon="mdi-account"
                    border="top"
                    prominent
                >
                    <v-row align="center">
                        <v-col class="grow text-h4">Real Property Tax Payment</v-col>
                    </v-row>
                </v-alert>
            </v-col>

            <v-col
                cols="12"
                v-if="!currentsoa._id"
            >
                <v-btn
                    text
                    @click="$router.push({name: 'tdnclaims'}).catch(()=>{})"
                >
                    <v-icon class="mr-2">mdi-file-document-edit-outline</v-icon>Claim Tax Declaration Number
                </v-btn>
            </v-col>

            <v-col
                cols="12"
                v-if="!currentsoa._id"
            >
                <!-- <v-select
                    :items="paymentterms"
                    item-text="text"
                    item-value="value"
                    v-model="paymentterm"
                    label="Payment Terms"
                    @change="ChangePaymentTerm"
                ></v-select> -->

                <v-select
                    :items="paymentterms"
                    item-text="text"
                    item-value="value"
                    v-model="paymentterm"
                    label="Payment Terms"
                    @change="RPTSoaRequest"
                ></v-select>
            </v-col>

            <v-col
                cols="12"
                v-if="!currentsoa._id"
            >
                <!-- <v-autocomplete
                    v-model="tdn"
                    :items="items"
                    :loading="loading"
                    :search-input.sync="search"
                    hide-no-data
                    hide-selected
                    item-text="tdnformatted"
                    item-value="TDN_IntKey"
                    label="Search Tax Declaration Number"
                    placeholder="Start typing to Search"
                    prepend-icon="mdi-database-search"
                    return-object
                ></v-autocomplete> -->

                <v-combobox
                    small-chips
                    v-model="tdnclaim"
                    :items="tdnclaims"
                    item-text="tdnformatted"
                    item-value="TDN_IntKey"
                    label="Select Tax Declaration Number"
                    return-object
                    multiple
                    append-outer-icon="mdi-check-bold"
                    @click:append-outer="RPTSoaRequest"
                    clearable
                ></v-combobox>
            </v-col>

            <v-col
                v-if="tdn !== null"
                cols="12"
                offset-lg="2"
                lg="8"
                md="10"
                offset-md="1"
            >
                <div style="display: none;" v-if="tdn.paymentrequest && tdn.paymentrequest.length > 0">
                    <div :id="`rpt-print`">
                        <img src="/images/tc.png" width="200" class="rounded mx-auto d-block" />

                        <h6 style="margin-top: 50px;">Please pay the amount due below online or by presenting this payment slip to the City Treasury Office.<br /><strong>This payment slip is valid until {{ eom }}</strong>.</h6>

                        <div class="alert">
                            <!-- <h3>{{ tdn.displayname }}</h3>
                            <h4>TDN #: {{ tdn.tdnformatted }}</h4> -->
                            <h4>Assessment #: {{ tdn.paymentrequest[0].AssessmentNumber }}</h4>
                        </div>

                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th class="text-center">
                                        Fee Type
                                    </th>
                                    <th class="text-center">
                                        Amount
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(tdnc, tdnci) in tdnclaim">
                                    <tr
                                        :key="`tdnclaim-print-${tdnci}`"
                                        v-if="tdn.paymentrequest.filter(x => {
                                            return x.TDN_IntKey.toString() == tdnc.TDN_IntKey.toString() && FullAdvanced(x)
                                        }).length > 0"
                                    >
                                        <td colspan="2"><h3>{{ tdnc.displayname }}</h3><h4>TDN #: {{ tdnc.tdnformatted }}</h4></td>
                                    </tr>

                                    <template v-for="(fee, i) in tdn.paymentrequest.filter(x => {
                                        return x.TDN_IntKey.toString() == tdnc.TDN_IntKey.toString()
                                    })">
                                        <tr
                                            :key="`fee-print-year-container-${tdnci}-${i}`"
                                            v-if="FullAdvanced(fee)"
                                        >
                                            <td colspan="2" class="text-center">
                                                <strong>{{ fee.Year }}</strong>
                                            </td>
                                        </tr>

                                        <tr
                                            :key="`fee-print-basictax-container-${tdnci}-${i}`"
                                            v-if="FullAdvanced(fee)"
                                        >
                                            <td>
                                                <strong>Basic Tax</strong>
                                            </td>
                                            <td>
                                                &#8369;{{ Numeral(fee.BasicTax) }}
                                            </td>
                                        </tr>

                                        <tr
                                            :key="`fee-print-basicdiscount-container-${tdnci}-${i}`"
                                            v-if="FullAdvanced(fee) && parseFloat(fee.BasicDiscount) !== 0"
                                        >
                                            <td>
                                                <strong>Basic Discount</strong>
                                            </td>
                                            <td>
                                                &#8369;{{ Numeral(fee.BasicDiscount) }}
                                            </td>
                                        </tr>

                                        <tr
                                            :key="`fee-print-basicpenalty-container-${tdnci}-${i}`"
                                            v-if="FullAdvanced(fee) && parseFloat(fee.BasicPenalty) !== 0"
                                        >
                                            <td>
                                                <strong>Basic Penalty</strong>
                                            </td>
                                            <td>
                                                &#8369;{{ Numeral(fee.BasicPenalty) }}
                                            </td>
                                        </tr>

                                        <tr
                                            :key="`fee-print-sef-container-${tdnci}-${i}`"
                                            v-if="FullAdvanced(fee)"
                                        >
                                            <td>
                                                <strong>SEF</strong>
                                            </td>
                                            <td>
                                                &#8369;{{ Numeral(fee.SEF) }}
                                            </td>
                                        </tr>

                                        <tr
                                            :key="`fee-print-sefdiscount-container-${tdnci}-${i}`"
                                            v-if="FullAdvanced(fee) && parseFloat(fee.SEFDiscount) !== 0"
                                        >
                                            <td>
                                                <strong>SEF Discount</strong>
                                            </td>
                                            <td>
                                                &#8369;{{ Numeral(fee.SEFDiscount) }}
                                            </td>
                                        </tr>

                                        <tr
                                            :key="`fee-print-sefpenalty-container-${tdnci}-${i}`"
                                            v-if="FullAdvanced(fee) && parseFloat(fee.SEFPenalty) !== 0"
                                        >
                                            <td>
                                                <strong>SEF Penalty</strong>
                                            </td>
                                            <td>
                                                &#8369;{{ Numeral(fee.SEFPenalty) }}
                                            </td>
                                        </tr>

                                        <tr
                                            :key="`fee-print-total-container-${tdnci}-${i}`"
                                            v-if="FullAdvanced(fee)"
                                        >
                                            <td class="text-right">
                                                <strong>Total: </strong>
                                            </td>
                                            <td>
                                                &#8369;{{ Numeral(fee.Total) }}
                                            </td>
                                        </tr>
                                    </template>
                                </template>

                                <tr>
                                    <td class="text-right">
                                        <strong>Grand Total: </strong>
                                    </td>
                                    <td>
                                        &#8369;{{ Numeral(GrandTotal(tdn.paymentrequest)) }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <v-card v-if="!currentsoa._id">
                    <!-- <template v-for="(tdnc, tdnci) in tdnclaim">
                        <v-card-text
                            :key="`tdnclaim-${tdnci}`"
                            class="py-0 my-0"
                        >
                            <v-card-title>{{ tdnc.displayname }} ({{ tdnc.tdnformatted }})</v-card-title>
                            <v-card-subtitle>
                                {{ tdnc.displayaddress }}
                            </v-card-subtitle>
                        </v-card-text>
                    </template> -->

                    <!-- <v-card-text>
                        <v-card-title>{{ tdn.displayname }} ({{ tdn.tdnformatted }})</v-card-title>
                        <v-card-subtitle>
                            {{ tdn.displayaddress }}
                        </v-card-subtitle>
                    </v-card-text> -->

                    <v-card-text
                        v-if="tdn.paymentrequest && tdn.paymentrequest.length > 0"
                    >
                        <v-card-title>Assessment #: {{ tdn.paymentrequest[0].AssessmentNumber }}</v-card-title>
                        <v-card-subtitle>Breakdown of Fees</v-card-subtitle>
                        
                        <template v-for="(tdnc, tdnci) in tdnclaim">
                            <v-card-text
                                :key="`tdnclaim-${tdnci}`"
                                class="py-0 my-0 px-0 mx-0"
                                v-if="tdn.paymentrequest.filter(x => {
                                    return x.TDN_IntKey.toString() == tdnc.TDN_IntKey.toString() && FullAdvanced(x)
                                }).length > 0"
                            >
                                <v-card-title>{{ tdnc.displayname }} ({{ tdnc.tdnformatted }})</v-card-title>
                                <v-card-subtitle>
                                    {{ tdnc.displayaddress }}
                                </v-card-subtitle>
                            </v-card-text>

                            <template v-for="(fee, i) in tdn.paymentrequest.filter(x => {
                                    return x.TDN_IntKey.toString() == tdnc.TDN_IntKey.toString()
                                })">
                                <v-row
                                    dense
                                    :key="`rpt-fee-container-${tdnci}-${i}`"
                                    v-if="FullAdvanced(fee)"
                                >
                                    <v-col
                                        cols="12"
                                    >
                                        <strong>Year: {{ fee.Year }}</strong>
                                    </v-col>
                                    <v-col
                                        cols="9"
                                    >
                                        <strong>Basic Tax</strong>
                                    </v-col>
                                    <v-col
                                        cols="3"
                                    >
                                        &#8369;{{ Numeral(fee.BasicTax) }}
                                    </v-col>

                                    <v-col
                                        cols="9"
                                        v-if="parseFloat(fee.BasicDiscount) !== 0"
                                    >
                                        <strong>Basic Discount</strong>
                                    </v-col>
                                    <v-col
                                        cols="3"
                                        v-if="parseFloat(fee.BasicDiscount) !== 0"
                                    >
                                        &#8369;{{ Numeral(fee.BasicDiscount) }}
                                    </v-col>

                                    <v-col
                                        cols="9"
                                        v-if="parseFloat(fee.BasicPenalty) !== 0"
                                    >
                                        <strong>Basic Penalty</strong>
                                    </v-col>
                                    <v-col
                                        cols="3"
                                        v-if="parseFloat(fee.BasicPenalty) !== 0"
                                    >
                                        &#8369;{{ Numeral(fee.BasicPenalty) }}
                                    </v-col>

                                    <v-col
                                        cols="9"
                                    >
                                        <strong>SEF</strong>
                                    </v-col>
                                    <v-col
                                        cols="3"
                                    >
                                        &#8369;{{ Numeral(fee.SEF) }}
                                    </v-col>

                                    <v-col
                                        cols="9"
                                        v-if="parseFloat(fee.SEFDiscount) !== 0"
                                    >
                                        <strong>SEF Discount</strong>
                                    </v-col>
                                    <v-col
                                        cols="3"
                                        v-if="parseFloat(fee.SEFDiscount) !== 0"
                                    >
                                        &#8369;{{ Numeral(fee.SEFDiscount) }}
                                    </v-col>

                                    <v-col
                                        cols="9"
                                        v-if="parseFloat(fee.SEFPenalty) !== 0"
                                    >
                                        <strong>SEF Penalty</strong>
                                    </v-col>
                                    <v-col
                                        cols="3"
                                        v-if="parseFloat(fee.SEFPenalty) !== 0"
                                    >
                                        &#8369;{{ Numeral(fee.SEFPenalty) }}
                                    </v-col>

                                    <v-col
                                        cols="9"
                                        style="border-top: 2px solid #000;"
                                    >
                                        <strong>Total:</strong>
                                    </v-col>
                                    <v-col
                                        cols="3"
                                        style="border-top: 2px solid #000;"
                                    >
                                        &#8369;{{ Numeral(fee.Total) }}
                                    </v-col>
                                </v-row>
                            </template>
                        </template>

                        <v-row
                            dense
                            class="mt-6"
                        >
                            <v-col
                                cols="9"
                                style="border-top: 2px solid #000;"
                            >
                                <strong>Grand Total:</strong>
                            </v-col>
                            <v-col
                                cols="3"
                                style="border-top: 2px solid #000;"
                            >
                                &#8369;{{ Numeral(GrandTotal(tdn.paymentrequest)) }}
                            </v-col>
                        </v-row>

                        <v-row
                            dense
                            class="d-none"
                        >
                            <v-col
                                cols="12"
                            >
                                <v-select
                                    :items="CheckFullAdvanced(tdn.paymentrequest)"
                                    item-text="text"
                                    item-value="value"
                                    v-model="tdn.paymentterms"
                                ></v-select>
                            </v-col>
                        </v-row>

                        <v-card-actions>
                            <v-spacer></v-spacer>

                            <v-btn
                                text
                                color="green darken-2"
                                dark
                                @click="PrintTDN({
                                    txnnumber: tdn.paymentrequest[0].AssessmentNumber || '',
                                })"
                            >
                                Print for Offline Payment
                            </v-btn>

                            <!-- <v-btn
                                text
                                color="red darken-2"
                                dark
                                @click="PrePayment(tdn)"
                                @click="AskOLPassword(tdn)"
                            >
                                Online Payment
                            </v-btn> -->
                            <v-btn
                                text
                                color="red darken-2"
                                dark
                                @click="AskOLPassword(tdn)"
                            >
                                Online Payment
                            </v-btn>
                        </v-card-actions>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col  
                cols="12"
                md="8"
                offset-md="2"
                lg="6"
                offset-lg="3"
                v-if="currentsoa._id"
            >
                <template v-if="prepaymentstep == 1">
                    <v-card
                        elevation="6"
                    >
                        <v-card-text>
                            <v-select
                                :items="paymentoptions"
                                item-text="text"
                                item-value="value"
                                label="Issuing Bank Type"
                                v-model="prepayment.paymentoption"
                            ></v-select>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>

                            <v-btn
                                dark
                                color="green darken-2"
                                @click="ProceedToNext"
                            >
                                Proceed<v-icon class="ml-2">mdi-arrow-right</v-icon>
                            </v-btn>

                            <v-btn
                                dark
                                color="red darken-2"
                                @click="ResetPayment"
                            >
                                Cancel
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </template>

                <template v-else-if="prepaymentstep == 2">
                    <v-card
                        elevation="6"
                    >
                        <v-card-text>
                            <p>
                                Issuing Bank Type: <strong>{{ paymentoptions.filter(x => x.value.toString() == prepayment.paymentoption.toString())[0].text }}</strong>
                            </p>

                            <v-select
                                :items="debitcredit"
                                item-text="text"
                                item-value="value"
                                label="Card Type"
                                v-model="prepayment.debitcredit"
                            ></v-select>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>

                            <v-btn
                                dark
                                color="green darken-2"
                                @click="ProceedToNext"
                            >
                                Proceed<v-icon class="ml-2">mdi-arrow-right</v-icon>
                            </v-btn>

                            <v-btn
                                dark
                                color="red darken-2"
                                @click="ResetPayment"
                            >
                                Cancel
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </template>

                <template v-else-if="prepaymentstep == 3">
                    <v-card
                        elevation="6"
                    >
                        <v-card-text>
                            <p>
                                Issuing Bank Type: <strong>{{ paymentoptions.filter(x => x.value.toString() == prepayment.paymentoption.toString())[0].text }}</strong>
                            </p>
                            <p>
                                Card Type: <strong>{{ prepayment.debitcredit }}</strong>
                            </p>
                            <v-alert
                                type="error"
                            >
                                For debit card holders, is your card enabled for online transaction?
                            </v-alert>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>

                            <v-btn
                                dark
                                color="green darken-2"
                                @click="ProceedToNext"
                            >
                                Yes
                            </v-btn>

                            <v-btn
                                dark
                                color="red darken-2"
                                @click="ResetPayment"
                            >
                                No, I will confirm it to my Bank
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </template>

                <template v-else-if="prepaymentstep == 4">
                    <v-card
                        elevation="6"
                    >
                        <v-card-text>
                            <p>
                                Issuing Bank Type: <strong>{{ paymentoptions.filter(x => x.value.toString() == prepayment.paymentoption.toString())[0].text }}</strong>
                            </p>

                            <template v-if="prepayment.api.toString() == 'Nationlink'">
                                <p v-if="prepayment.paymentoption && prepayment.paymentoption.toString() != 'Fortune Pay'">
                                    Card Type: <strong>{{ prepayment.debitcredit }}</strong>
                                </p>
                                <v-divider></v-divider>
                            </template>
                            <p class="mt-4">
                                Amount: <strong>&#8369;{{ Numeral(GrandTotal(currentsoa.paymentrequest)) }}</strong>
                            </p>
                            <template v-if="prepayment.api.toString() == 'Nationlink'">
                                <p>
                                    Convenience Fee: <strong>&#8369;{{ ComputeConvenienceFee() }}</strong>
                                </p>
                                <p>
                                    Total Amount: <strong>&#8369;{{ AmountToPay() }}</strong>
                                </p>
                            </template>

                            <template v-if="prepayment.api.toString() == 'Unionbank'">
                                <p class="text-h6">Convenience Fee</p>
                                <p>Unionbank UBOnline: <strong>&#8369;10</strong></p>
                                <p>Unionbank Instapay: <strong>&#8369;15</strong></p>
                                <p>Unionbank PCHC Paygate: <strong>&#8369;25</strong></p>
                            </template>
                        </v-card-text>

                        <v-card-text>
                            <v-divider></v-divider>

                            <template>
                                <v-checkbox
                                    v-model="prepayment.agreement.conveniencefee"
                                    label="Do you agree to pay the convenience fee stated above?"
                                ></v-checkbox>
                            </template>

                            <template>
                                <v-checkbox
                                    v-model="prepayment.agreement.amounttobepaid"
                                    label="Do you agree to pay the total amount stated above?"
                                ></v-checkbox>
                            </template>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>

                            <v-btn
                                dark
                                color="green darken-2"
                                :disabled="!prepayment.agreement.conveniencefee || !prepayment.agreement.amounttobepaid"
                                @click="ProceedToNext"
                            >
                                Proceed to Payment<v-icon class="ml-2">mdi-arrow-right</v-icon>
                            </v-btn>

                            <v-btn
                                dark
                                color="red darken-2"
                                @click="ResetPayment"
                            >
                                Cancel
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </template>
            </v-col>
        </v-row>

        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-dialog
            v-model="redirectionmessage"
            scrollable
            max-width="550"
            overlay-opacity="0.2"
            persistent
        >
            <v-card>
                <v-card-title class="headline deep-orange darken-1 white--text"><i class="mdi mdi-alert-outline mr-2"></i>Redirection Message</v-card-title>

                <v-card-text>
                    <v-row>   
                        <v-col
                            cols="12"
                        >
                            <p class="mb-2">Your security is important to us.</p>
                            <p class="mb-6">To proceed to your transaction, you will now be redirected to an online payment facility.</p>
                            <p class="mb-2">Ang inyong seguridad ay mahalaga sa amin.</p>
                            <p>Upang tumuloy sa inyong transaksyon, ididirekta po kayo sa isang online payment facility.</p>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions
                    class="deep-orange darken-1"
                >
                    <v-spacer></v-spacer>

                    <v-btn 
                        text
                        dark
                        @click="RedirectToPaymentFacility"
                    >Proceed</v-btn>

                    <v-btn 
                        text
                        dark
                        @click="redirectionmessage = false"
                    >Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="olpaymentpassmodal"
            scrollable
            max-width="550"
            overlay-opacity="0.2"
            persistent
        >
            <v-card>
                <v-card-title class="headline deep-orange darken-1 white--text"><i class="mdi mdi-lock mr-2"></i>Online Payment is Currently on Test Mode</v-card-title>

                <v-card-text>
                    <v-row>   
                        <v-col
                            cols="12"
                        >
                            <v-text-field
                                v-model="olpaymentpass"
                                label="Enter Test Mode Password"
                                outlined
                                type="password"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions
                    class="deep-orange darken-1"
                >
                    <v-spacer></v-spacer>

                    <v-btn 
                        text
                        dark
                        @click="VerifyPassword"
                    >Verify Password
                    </v-btn>

                    <v-btn 
                        text
                        dark
                        @click="olpaymentpassmodal = false"
                    >Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import _ from "lodash"
import { State, interpret } from "xstate"
import { toggleMachine } from "../../states/toggle"
import axios from "axios"
import numeral from "numeral"
import moment from "moment"

export default {
    props: [ 'GenerateUB_Cipher', 'randHex', 'UpdateTransactionUB', 'CheckIfLoggedInInternal' ],
    name: 'rpt',
    metaInfo: {
        title: 'Digital Tuguegarao - Real Property Tax Payment',
    },
    data() {
        return {
            redirectionmessage: false,
            eom: '',
            exceptfor: 'TTTL_000003',
            olpaymentpassmodal: false,
            olpaymentpass: '',
            olpaymentsoa: {},
            paymentterm: 'Y',
            paymentoptions: [
                // temporary disabled 2022-06-03
                // {
                //     text: 'Nationlink (Local and International Debit and Credit Cards)',
                //     value: 'National',
                // },
                // end
                // {
                //     text: 'International',
                //     value: 'International',
                // },
                {
                    // text: 'Unionbank',
                    text: 'Unionbank (Unionbank accounts, Instapay, PCHC Paygate)',
                    value: 'Unionbank',
                },
                // {
                //     text: 'Fortune Pay (Coming Soon)',
                //     value: 'Fortune Pay',
                //     disabled: true,
                // },
            ],
            debitcredit: [
                {
                    text: 'Debit',
                    value: 'Debit'
                },
                {
                    text: 'Credit',
                    value: 'Credit',
                },
            ],
            prepayment: {
                nameofissuingbank: '',
                paymentoption: 'National',
                debitcredit: 'Debit',
                agreement: {
                    conveniencefee: false,
                    amounttobepaid: false,
                },
                bankcharges: 0,
                nationlinkcharges: 0,
                api: 'Unionbank',
            },
            conveniencefee: 0,
            prepaymentstep: 1,
            currentsoa: {},
            toggleService: interpret(toggleMachine),
            current: toggleMachine.initialState,
            context: toggleMachine.context,
            tdn: null,
            loading: false,
            search: null,
            entries: [],
            searchcancel: null,
            overlay: false,
            paymentterms: [
                {
                    text: 'Quarterly',
                    value: 'Q',
                    disabled: false,
                },
                {
                    text: 'Semi-Annual',
                    value: 'S',
                    disabled: false,
                },
                {
                    text: 'Full',
                    value: 'Y',
                    disabled: false,
                },
                {
                    text: 'Advanced',
                    value: 'A',
                    disabled: true,
                }
            ],
            tdnclaims: [],
            tdnclaim: [],
        }
    },
    computed: {
        items() {
            return this.entries.map(x => {
                let tdnformatted = x.TDN_IntKey.toString()

                const possiblesuffix = _.padStart(x.DeclarationNo.toString(), 5, '0')
                // const remaining = x.ARPNo.toString()
                // let possibleprefix = _.padStart(x.ARPNo.toString().replace(possiblesuffix, ''), 2, '0')
                // let possibleprefix = _.padStart(_.trimEnd(x.ARPNo.toString(), x.DeclarationNo.toString()), 2, '0')
                const possibleprefix = _.padStart(x.ARPNo.toString().substr(0, x.ARPNo.toString().length - x.DeclarationNo.toString().length), 2, '0')

                // if(x.ARPNo.toString().replace(possiblesuffix, '').toString().length > 2){
                //     possibleprefix = _.padStart(_.trimEnd(x.ARPNo.toString(), x.DeclarationNo.toString()), 2, '0')
                // }

                // console.log(`${x.ARPNo.toString()} ${possiblesuffix} ${possibleprefix}`)
                if(possiblesuffix.toString().length > 0 && possibleprefix.toString().length > 0){
                    tdnformatted = `${possibleprefix}-${possiblesuffix}`

                    if(x.tdnsuffix.toString().length > 0){
                        tdnformatted = `${tdnformatted}-${x.tdnsuffix}`
                    }
                }

                const displaynameaddress = x.DisplayNameAddress.toString().split(';')
                const displayname = _.trim(displaynameaddress[0])
                const displayaddress = _.trim(displaynameaddress[1])

                const paymentterms = 'Full'

                return Object.assign({}, x, { tdnformatted, displayname, displayaddress, paymentterms })
            })
        }
    },
    watch: {
        // tdn(newval) {
        //     // console.log(newval)

        //     if(newval){
        //         this.overlay = true
        //         // http://35.220.187.169/Treasury/APIS/RPTAPI.php?function=CreateSOA&TDNIntKey=2001013R83554
        //         axios({
        //             method: 'post',
        //             url: `${this.domain}/op_rpt_soa`,
        //             data: {
        //                 tdn: newval.TDN_IntKey.toString(),
        //                 paymentterm: this.paymentterm,
        //             }
        //         })
        //             .then(response => {
        //                 this.overlay = false
        //                 // this.search = null
        //                 // this.items = []

        //                 if(response.data.response){
        //                     const soa = this.$jwt.decode(response.data.soa, this.jwtsecret)

        //                     const topaytdn = JSON.parse(soa.soa)

        //                     // console.log(topaytdn)

        //                     this.tdn.paymentrequest = topaytdn 
        //                 }
        //             })
        //             .catch(() => {
        //                 this.overlay = false
        //             })
        //     }
        // },
        search () {
            // Items have already been loaded
            // if (this.acitems.length > 0) return

            if(this.searchcancel){
                this.searchcancel.cancel()
                this.loading = false
            }

            // Items have already been requested
            if (this.loading) return

            if (!this.search) return

            if (this.search.toString().length == 0) return

            this.loading = true

            this.searchcancel = axios.CancelToken.source()

            axios({
                method: 'post',
                url: `${this.domain}/op_rpt_search_tdn`,
                data: {
                    search: this.search.toString(),
                }
            })
                .then(response => {
                    this.loading = false

                    const entries = this.$jwt.decode(response.data.items, this.jwtsecret)

                    this.entries = entries.items

                    console.log(this.entries)
                })
                .catch(err => {
                    console.log(err)
                })
                .finally(() => (this.loading = false))
        },
    },
    methods: {
        RPTSoaRequest() {
            if(this.tdnclaim.length > 0){
                this.tdn = this.tdnclaim[0]

                this.overlay = true
                // http://35.220.187.169/Treasury/APIS/RPTAPI.php?function=CreateSOA&TDNIntKey=2001013R83554
                axios({
                    method: 'post',
                    url: `${this.domain}/op_rpt_soa`,
                    data: {
                        tdn: this.tdnclaim.map(x => {
                            return x.TDN_IntKey.toString()
                        }).join(','),
                        paymentterm: this.paymentterm,
                    }
                })
                    .then(response => {
                        this.overlay = false
                        // this.search = null
                        // this.items = []

                        if(response.data.response){
                            const soa = this.$jwt.decode(response.data.soa, this.jwtsecret)

                            // console.log(soa)

                            const topaytdn = JSON.parse(soa.soa)

                            // console.log(topaytdn)

                            this.tdn.paymentrequest = topaytdn 
                        }
                    })
                    .catch(() => {
                        this.overlay = false
                    })
            }
        },
        TDN_Format(x) {
            let tdnformatted = x.TDN_IntKey.toString()

            const possiblesuffix = _.padStart(x.DeclarationNo.toString(), 5, '0')
            // const remaining = x.ARPNo.toString()
            // let possibleprefix = _.padStart(x.ARPNo.toString().replace(possiblesuffix, ''), 2, '0')
            // let possibleprefix = _.padStart(_.trimEnd(x.ARPNo.toString(), x.DeclarationNo.toString()), 2, '0')
            const possibleprefix = _.padStart(x.ARPNo.toString().substr(0, x.ARPNo.toString().length - x.DeclarationNo.toString().length), 2, '0')

            // if(x.ARPNo.toString().replace(possiblesuffix, '').toString().length > 2){
            //     possibleprefix = _.padStart(_.trimEnd(x.ARPNo.toString(), x.DeclarationNo.toString()), 2, '0')
            // }

            // console.log(`${x.ARPNo.toString()} ${possiblesuffix} ${possibleprefix}`)
            if(possiblesuffix.toString().length > 0 && possibleprefix.toString().length > 0){
                tdnformatted = `${possibleprefix}-${possiblesuffix}`

                if(x.tdnsuffix.toString().length > 0){
                    tdnformatted = `${tdnformatted}-${x.tdnsuffix}`
                }
            }

            const displaynameaddress = x.DisplayNameAddress.toString().split(';')
            const displayname = _.trim(displaynameaddress[0])
            const displayaddress = _.trim(displaynameaddress[1])

            const paymentterms = 'Full'

            return {
                displaynameaddress,
                displayname,
                displayaddress,
                tdnformatted,
                paymentterms,
            }
        },
        GetTDNClaims() {
            this.tdnclaims = []

            axios({
                method: 'post',
                url: `${this.domain}/crm_user_tdn_claims`,
                data: {
                    uid: this.context.citizen._id.toString(),
                }
            })
                .then(response => {
                    if(response.data.response){
                        const items = this.$jwt.decode(response.data.items, this.jwtsecret)

                        // console.log(items)
                        if(items.items.length > 0){
                            this.tdnclaims = items.items.filter(x => {
                                return x.tdndetails.length > 0
                            }).map(x => {
                                const {
                                    displayname,
                                    displayaddress,
                                    tdnformatted,
                                    paymentterms,
                                } = this.TDN_Format(x.tdndetails[0])

                                return Object.assign({}, x.tdndetails[0], { tdnformatted, displayname, displayaddress, paymentterms })
                            })
                        } else{
                            this.$router.push({name: 'tdnclaims'}).catch(()=>{})
                        }
                    }
                })
        },
        ChangePaymentTerm() {
            if(this.tdn !== null){
                this.overlay = true
                // http://35.220.187.169/Treasury/APIS/RPTAPI.php?function=CreateSOA&TDNIntKey=2001013R83554
                axios({
                    method: 'post',
                    url: `${this.domain}/op_rpt_soa`,
                    data: {
                        tdn: this.tdn.TDN_IntKey.toString(),
                        paymentterm: this.paymentterm,
                    }
                })
                    .then(response => {
                        this.overlay = false
                        // this.search = null
                        // this.items = []

                        if(response.data.response){
                            const soa = this.$jwt.decode(response.data.soa, this.jwtsecret)

                            const topaytdn = JSON.parse(soa.soa)

                            console.log(topaytdn)

                            this.tdn.paymentrequest = topaytdn 
                        }
                    })
                    .catch(() => {
                        this.overlay = false
                    })
            }
        },
        AmountToPay() {
            const amount = this.GrandTotal(this.currentsoa.paymentrequest)
            const cf = this.ConvenienceFee(amount)

            return this.Numeral(amount + cf)
        },
        ComputeConvenienceFee() {
            return this.Numeral(this.ConvenienceFee(this.GrandTotal(this.currentsoa.paymentrequest)))
        },
        NationlinkCF(total) {
            let cf = 50

            if(total > 2500 && total <= 7500) {
                cf = 75
            } else if(total > 7500 && total <= 15000) {
                cf = 100
            } else if(total > 15000 && total <= 30000) {
                cf = 150
            } else if(total > 30000 && total <= 50000) {
                cf = 290
            } else if(total > 50000 && total <= 80000) {
                cf = 460
            } else if(total > 80000 && total <= 120000) {
                cf = 650
            } else if(total > 120000 && total <= 175000) {
                cf = 915
            } else if(total > 175000 && total <= 210000) {
                cf = 1100
            } else if(total > 210000 && total <= 400000) {
                cf = 2100
            } else if(total > 400000) {
                cf = 3000
            }

            return cf
        },
        ConvenienceFee(total = 0) {
            let cffee = 0

            if(this.prepayment.paymentoption && this.prepayment.paymentoption.toString() == 'Fortune Pay'){
                return cffee
            }

            switch(this.prepayment.paymentoption.toString()) {
                case 'National':
                    if(this.prepayment.debitcredit.toString() == 'Debit'){
                        // 2% for debit
                        this.prepayment.bankcharges = total * 0.02
                    } else{
                        // 4% for credit
                        this.prepayment.bankcharges = total * 0.04
                    }
                    break;
                case 'International':
                    if(this.prepayment.debitcredit.toString() == 'Debit'){
                        // 2% for debit
                        this.prepayment.bankcharges = total * 0.02
                    } else{
                        // 4% for credit
                        this.prepayment.bankcharges = total * 0.04
                    }
                    break;
                case 'Fortune Pay':
                    // cffee = (total * 0.035) + 70
                    this.prepayment.bankcharges = total * 0.035
                    break;
            }
            
            this.prepayment.nationlinkcharges = this.NationlinkCF(total)
            // const cffee = (total * 0.035) + 70
            cffee = this.prepayment.bankcharges + this.prepayment.nationlinkcharges

            this.conveniencefee = cffee

            return cffee
        },
        ResetPayment() {
            this.currentsoa = {}

            this.prepayment = {
                nameofissuingbank: '',
                paymentoption: 'National',
                debitcredit: 'Debit',
                agreement: {
                    conveniencefee: false,
                    amounttobepaid: false,
                },
                bankcharges: 0,
                nationlinkcharges: 0,
                api: 'Nationlink',
            }

            this.prepaymentstep = 1

            // this.fetch()
        },
        RedirectToPaymentFacility() {
            if(this.prepayment.agreement.conveniencefee && this.prepayment.agreement.amounttobepaid){
                this.ProceedToPayment(this.currentsoa)
            }
        },
        ProceedToNext() {
            switch(parseInt(this.prepaymentstep)) {
                case 1:
                    switch(this.prepayment.paymentoption.toString()) {
                        case 'National': case 'International': 
                            this.prepaymentstep = 2
                            break;
                        case 'Fortune Pay':
                            this.prepaymentstep = 4
                            // go to fortunepay page
                            // this.ProceedToPayment(this.currentsoa)
                            break;
                        case 'Unionbank':
                            this.prepaymentstep = 4
                            this.prepayment.api = 'Unionbank'
                            this.prepayment.agreement.conveniencefee = false
                            break;
                    }
                    break;
                case 2:
                    if(this.prepayment.debitcredit.toString() == 'Debit') {
                        this.prepaymentstep = 3
                    } else{
                        this.prepaymentstep = 4
                    }
                    break;
                case 3:
                    this.prepaymentstep = 4
                    break;
                case 4:
                    if(this.prepayment.agreement.conveniencefee && this.prepayment.agreement.amounttobepaid){
                        // this.ProceedToPayment(this.currentsoa)
                        // alert(111111)
                        // this.redirectionmessage = true

                        if(this.prepayment.api.toString() == 'Nationlink') {
                            this.ProceedToPayment(this.currentsoa)
                        } else if(this.prepayment.api.toString() == 'Unionbank') {
                            this.redirectionmessage = true
                        }
                    }
                    break;
            }
        },
        PrintTDN(tr) {
            axios({
                method: 'post',
                url: `${this.domain}/OfflinePaymentPrint`,
                data: {
                    uid: this.citizen._id.toString(),
                    txnnumber: tr.txnnumber.toString(),
                    type: 'RPT',
                }
            })
                .then(response => {
                    if(response.data.response){
                        this.$htmlToPaper(`rpt-print`)
                    } else{
                        this.$emit('snackbar', {
                            variant: 'red darken-2',
                            message: 'Something went wrong.. Try again later...'
                        })
                    }
                })
        },
        CheckFullAdvanced(pr) {
            this.paymentterms.forEach(x => {
                x.disabled = false
            })

            let fullpayment = this.paymentterms.filter(x => {
                return x.value.toString() == 'Full'
            })

            const hascurrentyear = pr.filter(x => {
                return parseInt(x.Year) <= parseInt(moment().format('YYYY'))
            })

            if(hascurrentyear.length == 0 && fullpayment.length > 0){
                fullpayment[0].disabled = true
            }

            return this.paymentterms
        },
        VerifyPassword() {
            if(this.olpaymentpass.toString() == this.onlinepaymentpass.toString()){
                this.olpaymentpassmodal = false
                this.PrePayment(this.olpaymentsoa)
                this.olpaymentsoa = {}
            } else{
                alert('Incorrect Module Password')
            }
        },
        AskOLPassword(soa) {
            if((this.sysconfig && this.sysconfig.paymenttestmode && this.sysconfig.paymenttestmode == true) || !this.sysconfig){
                this.olpaymentsoa = soa
                this.olpaymentpass = ''
                this.olpaymentpassmodal = true
            } else{
                this.olpaymentpassmodal = false
                this.PrePayment(soa)
                this.olpaymentsoa = {}
            }
        },
        PrePayment(soa) {
            // console.log(soa)
            this.currentsoa = soa

            this.prepayment = {
                // old
                // nameofissuingbank: '',
                // paymentoption: 'National',
                // new
                nameofissuingbank: this.paymentoptions.length == 1 ? this.paymentoptions[0].text : '',
                paymentoption: this.paymentoptions.length == 1 ? this.paymentoptions[0].value : 'National',
                debitcredit: 'Debit',
                agreement: {
                    conveniencefee: false,
                    amounttobepaid: false,
                },
                bankcharges: 0,
                nationlinkcharges: 0,
                api: this.paymentoptions.length == 1 ? this.paymentoptions[0].value : 'Nationlink',
            }

            // this.prepaymentstep = 4

            this.prepaymentstep = 1
            
            // added
            if(this.paymentoptions.length == 1) {
                this.ProceedToNext()
            }
        },
        ProceedToPayment(soa) {
            // console.log(soa)

            this.overlay = true

            axios({
                method: 'post',
                url: `${this.domain}/op_proceed_to_payment`,
                data: {
                    division: 'RPT',
                    citizenid: this.context.citizen._id.toString(),
                    amount: this.Numeral(this.GrandTotal(soa.paymentrequest)),
                    linkid: soa._id.toString(),
                    paymentslip: soa.paymentrequest[0].AssessmentNumber.toString(),
                    items: JSON.stringify(soa.paymentrequest),
                    quarter: 4,
                    // paymentduration: soa.paymentterms.toString(),
                    paymentduration: this.paymentterm.toString(),
                    prepayment: JSON.stringify(this.prepayment),
                }
            })
                .then(response => {
                    this.overlay = false

                    if(response.data.response){
                        const requestd = this.$jwt.decode(response.data.newid, this.jwtsecret)
                        let ublink = ''

                        switch(this.prepayment.api.toString()) {
                            case 'Nationlink':
                                if(requestd.newid && requestd.newid.toString().length > 0){
                                    this.$router.push({
                                        name: 'payment',
                                        params: {
                                            requestid: requestd.newid.toString(),
                                        }
                                    }).catch(() => {})
                                }
                                break;
                            case 'Unionbank':
                                ublink = this.GenerateUB_Cipher({
                                    Amt: this.GrandTotal(soa.paymentrequest),
                                    // Redir: `${this.localdomain}rptpayment`,
                                    Redir: `${this.localdomain}payments/eor/${requestd.newid.toString()}`,
                                    TransactionId: requestd.newid.toString(),
                                    TransactionType: 'RPT',
                                    Department: 'Assessors',
                                })

                                // window.location = ublink.url.toString()
                                this.UpdateTransactionUB({
                                    id: requestd.newid.toString(),
                                    data: ublink.data,
                                }, () => {
                                    window.location = ublink.url.toString()
                                })
                                break;
                        }

                        // const ublink = this.GenerateUB_Cipher({
                        //     Amt: this.GrandTotal(soa.paymentrequest),
                        //     Redir: `${this.localdomain}rptpayment`,
                        //     TransactionId: requestd.newid.toString(),
                        //     TransactionType: 'RPT',
                        //     Department: 'Assessors',
                        // })

                        // window.location = ublink.toString()
                    } else{
                        this.$emit('snackbar', {
                            variant: 'red darken-2',
                            message: response.data.message.toString()
                        })
                    }
                })
                .catch(() => {
                    this.overlay = false

                    this.$emit('snackbar', {
                        variant: 'red darken-2',
                        message: 'Something went wrong.. check again later..'
                    })
                })
        },
        FullAdvanced(fee) {
            // return terms.toString() == 'Advanced' ? true : parseInt(fee.Year) <= parseInt(moment().format('YYYY'))
            return parseInt(fee.Year) <= parseInt(moment().format('YYYY'))
        },
        GrandTotal(pr) {
            let total = 0

            pr.forEach(x => {
                // if(terms.toString() == 'Advanced' || parseInt(x.Year) <= parseInt(moment().format('YYYY'))){
                //     total += parseFloat(x.Total)
                // }

                if(parseInt(x.Year) <= parseInt(moment().format('YYYY'))){
                    total += parseFloat(x.Total)
                }
            })

            return total
        },
        Numeral(num) {
            return numeral(parseFloat(num)).format('0,0.00')
        },
        SystemConfig() {
            axios({
                method: 'post',
                url: `${this.domain}/crm_sys_config`,
                data: {
                    uid: this.context.citizen._id.toString(),
                }
            })
                .then(response => {
                    const config = this.$jwt.decode(response.data.config, this.jwtsecret)
                    this.sysconfig = config.config
                })
        },
    },
    mounted() {
        this.CheckIfLoggedInInternal()

        const { user } = this.$jwt.decode(this.$session.get('crmusersessionsignature'), this.jwtsecret)
        user.mobile = user.mobile || ''
        delete user.passwd
        delete user.signature

        this.citizen = _.cloneDeep(user)

        this.toggleService.send({
            type: 'CITIZEN',
            citizen: this.citizen
        })

        // check
        this.CRM_Interval = setInterval(() => {
            if(!(this.$ls.get('isLoggedIn') && this.$session.exists() && this.$session.get('crmusersessionsignature'))){
                clearInterval(this.CRM_Interval)

                this.$router.push({
                    name: 'login'
                }).catch(()=>{})
            }
        }, 500)

        this.GetTDNClaims()

        this.SystemConfig()

        this.eom = moment().clone().endOf('month').format('MMMM D, YYYY')
    },
    created() {
        const stateDefinition = JSON.parse(localStorage.getItem('app-xstate')) || toggleMachine.initialState
        stateDefinition.context.paymentrequest = {}
        const previousState = State.create(stateDefinition)
        const resolvedState = toggleMachine.resolveState(previousState)

        this.toggleService
            .onTransition(state => {
                this.current = state
                this.context = state.context

                localStorage.setItem('app-xstate', JSON.stringify(state))
            })
            .start(resolvedState)
    }
}
</script>